import { useQuery } from "react-query";

import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { zodParseWithLog } from "../../apiErrorLogs";
import { BrandSchema } from "./brandSchemas";

export { BrandSchema };
export type { Brand } from "./brandSchemas";

export const getOneBrandKey = "oneBrand" as const;

type Options = {
    enabled?: boolean;
};

export const useGetOneBrand = (brandId: string, options?: Options) => {
    const { enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getOneBrandKey, brandId],
        enabled: enabled,
        cacheTime: 0,
        queryFn: async () => {
            const url = `/api/brands/${brandId}`;
            return await loggedInApiCall.get(url);
        },
        select: (request) => {
            const brands = request.data;
            const data = zodParseWithLog(brands, BrandSchema, getOneBrandKey);
            return data;
        },
    });

    return {
        brand: query.data,
        ...query,
    };
};
